import { TicketOfficeView } from '../../../types/ticket-office';
import { InternalInfoProps } from '../../components/InternalInfo';

export const getInternalInfoProps = (view: TicketOfficeView): InternalInfoProps | undefined => {
    const { state, update } = view;
    const { lang, event, internalInfoExpanded } = state;

    if (!event.internalInfo) {
        return;
    }

    return {
        isExpanded: internalInfoExpanded,
        text: event.internalInfo,
        closeText: lang.common.close,
        setExpanded: (isExpanded): void => {
            state.internalInfoExpanded = isExpanded;
            update();
        },
    };
};
